/* @flow */
import React, { Component, PureComponent, Children, cloneElement } from "react";

import type { Element, ChildrenArray } from "react";

type SubscriptionProps = {
  op: string,
  socket: WebSocket,
  onMessage: (data: Object) => void
};

export class Subscription extends Component<SubscriptionProps> {
  handleMessage = (event: Event) => {
    if (typeof event.data === "string") {
      try {
        const data = JSON.parse(event.data);

        if (data.op === this.props.op) {
          this.props.onMessage(data);
        }
      } catch (error) {
        // Надо ли что-то делать?
      }
    }
  };

  componentDidMount() {
    this.props.socket.addEventListener("message", this.handleMessage);
  }

  componentDidUpdate(prevProps: SubscriptionProps) {
    if (this.props.socket !== prevProps.socket) {
      prevProps.socket.removeEventListener("message", this.handleMessage);
      this.props.socket.addEventListener("message", this.handleMessage);
    }
  }

  componentWillUnmount() {
    this.props.socket.removeEventListener("message", this.handleMessage);
  }

  render() {
    return null;
  }
}

function safelySend(socket, data) {
  if (socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(data));
  }
}

type StockSubscriptionProps = {
  stock: string,
  socket: WebSocket,
  onMessage: (data: Object) => void
};

export class StockSubscription extends Component<StockSubscriptionProps> {
  handleMessage = (data: Object) => {
    if (data.stock === this.props.stock) {
      this.props.onMessage(data);
    }
  };

  componentDidMount() {
    safelySend(this.props.socket, { op: "subscribe", stock: this.props.stock });
  }

  componentDidUpdate(prevProps: StockSubscriptionProps) {
    if (this.props.stock !== prevProps.stock) {
      safelySend(this.props.socket, {
        op: "unsubscribe",
        stock: prevProps.stock
      });
      safelySend(this.props.socket, {
        op: "subscribe",
        stock: this.props.stock
      });
    }
  }

  componentWillUnmount() {
    safelySend(this.props.socket, {
      op: "unsubscribe",
      stock: this.props.stock
    });
  }

  render() {
    return (
      <Subscription
        op="stockPush"
        socket={this.props.socket}
        onMessage={this.handleMessage}
      />
    );
  }
}

export class PercentSubscription extends Component<StockSubscriptionProps> {
  handleMessage = (data: Object) => {
    if (data.channel === this.props.stock) {
      this.props.onMessage(data);
    }
  };

  componentDidMount() {
    safelySend(this.props.socket, {
      op: "sql-subscribe",
      channel: this.props.stock
    });
  }

  componentDidUpdate(prevProps: StockSubscriptionProps) {
    if (this.props.stock !== prevProps.stock) {
      safelySend(this.props.socket, {
        op: "sql-unsubscribe",
        channel: prevProps.stock
      });
      safelySend(this.props.socket, {
        op: "sql-subscribe",
        channel: this.props.stock
      });
    }
  }

  componentWillUnmount() {
    safelySend(this.props.socket, {
      op: "sql-unsubscribe",
      channel: this.props.stock
    });
  }

  render() {
    return (
      <Subscription
        op="percent-updated"
        socket={this.props.socket}
        onMessage={this.handleMessage}
      />
    );
  }
}

type Props = {
  url: string,
  readyState: number,
  onChange: (event: Event) => void,
  children?: ChildrenArray<
    Element<typeof Subscription | typeof StockSubscription>
  >
};

class Socket extends PureComponent<Props> {
  socket: WebSocket;

  handleStateChange = (event: Event) => {
    this.props.onChange(event);

    // Отсоединить событие "close" можно только
    // после закрытия. Иначе мы просто о нём не
    // узнаем.
    if (event.target.readyState === WebSocket.CLOSED) {
      event.target.removeEventListener("close", this.handleStateChange);
    }
  };

  connect = () => {
    try {
      this.socket = new WebSocket(this.props.url);

      this.socket.addEventListener("open", this.handleStateChange);
      this.socket.addEventListener("close", this.handleStateChange);
      this.socket.addEventListener("error", this.handleStateChange);
    } catch (error) {
      console.warn("Something's wrong with socket connection", error);
    }
  };

  disconnect = () => {
    try {
      this.socket.close();

      this.socket.removeEventListener("open", this.handleStateChange);
      this.socket.removeEventListener("error", this.handleStateChange);

      delete this.socket;
    } catch (error) {
      console.warn("Something's wrong with socket disconnect", error);
    }
  };

  constructor(props) {
    super(props);
    this.connect();
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.url !== prevProps.url) {
      this.disconnect();
      this.connect();
    }

    // TODO: Инициировать .close(), если
    // readyState был изменён вручную
  }

  componentWillUnmount() {
    this.disconnect();
  }

  render() {
    if (this.props.readyState === WebSocket.OPEN) {
      return Children.map(this.props.children, (child, index) =>
        cloneElement(child, {
          socket: this.socket
        })
      );
    }

    return null;
  }
}

export default Socket;



// WEBPACK FOOTER //
// ./src/components/Socket.js